import React, { useState } from 'react';
import { IonItem, IonLabel, IonIcon, IonImg, IonButton } from '@ionic/react';
import { personOutline } from 'ionicons/icons';
import { colors } from '../theme/colors';
import StandardContainer from '../commonComponents/standardContainer';

export default function HistoryNoAppointments({ }) {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <StandardContainer padding={0}>
      <div style={{
        width: '100%',
        height: '320px', // Adjust this to match your image's aspect ratio
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: -20,
        position: 'relative',
      }}>
        <IonImg 
          src={'/assets/getStarted.png'} 
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
            opacity: imageLoaded ? 1 : 0,
            transition: 'opacity 1s ease-out',
          }}
          onIonImgDidLoad={() => setImageLoaded(true)}
        />
      </div>
      <p style={{marginLeft:22, fontSize:13}}>H I S T O R Y </p>
      <h1 style={{marginLeft:20, marginTop:-6, fontSize:38}}>Book your first appointment</h1>
      <IonItem
        lines="none"
        button
        detail={false}
        style={{
          borderRadius: '10px',
          marginBottom: '1rem',
          backgroundColor: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <p style={{lineHeight:1.5, marginLeft:4, fontSize:18, marginTop:0}}>Booking and appointment is easy. In 60 seconds or less, you will be on your way to getting the haircut you have always wanted.</p>

        
      </IonItem>

      <IonButton routerLink='/schedule' routerDirection='none' expand='block' color='primary' style={{margin:20}}>Book Appointment</IonButton>
    </StandardContainer>
  );
}
